export default __webpack_public_path__ + "static/media/Prima_dummy.cae91678.png";